import { COLORS } from '../../settings/common';

export function Schema() {
  return {
    category: 'Text',
    label: 'Accordions Plus',
    key: 'accordions-plus',
    previewSrc:
      'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/accordions-preview.jpg?v=1675730300',
    fields: [
      {
        label: 'Heading',
        name: 'heading',
        component: 'text',
        defaultValue: 'Accordion Plus Heading',
      },
      {
        label: 'Accordion Plus',
        name: 'accordions',
        component: 'group-list',
        itemProps: {
          label: '{{item.header}}',
        },
        fields: [
          {
            label: 'Header',
            name: 'header',
            component: 'text',
          },
          {
            label: 'Body',
            name: 'body',
            component: 'markdown',
          },
          {
            label: 'Default Open',
            name: 'defaultOpen',
            component: 'toggle',
            description: 'Sets accordion to be open by default',
            toggleLabels: {
              true: 'On',
              false: 'Off',
            },
          }, 
          {
            label: 'Images',
            name: 'images',
            description: 'Grid requires four images',
            component: 'group-list',
            itemProps: {
              label: '{{item.alt}}',
            },
            validate: {
              maxItems: 64,
            },
            fields: [
              {
                label: 'Image Alt',
                name: 'alt',
                component: 'text',
                description: 'Brief description of image',
              },
              {
                label: 'Image',
                name: 'image',
                component: 'image',
              },
              {
                label: 'Image Link',
                name: 'link',
                component: 'link',
              },
              {
                label: 'Image Size',
                name: 'imageSize',
                component: 'text',
                description: 'Size of image',
              },
              {
                label: 'Show Pop Up',
                name: 'showPopUp',
                component: 'toggle',
                description: 'Show pop up on image click',
                toggleLabels: {
                  true: 'On',
                  false: 'Off',
                },
              }
            ],
            defaultItem: {
              alt: 'Man in white short sleeve shirt',
              image: {
                src: 'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/kenzie-kraft-9QW52RyBLao-unsplash.jpg?v=1672348135',
              },
              showPopUp: false,
            },
            defaultValue: [
              {
                alt: 'Man in white short sleeve shirt',
                image: {
                  src: 'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/kenzie-kraft-9QW52RyBLao-unsplash.jpg?v=1672348135',
                },
                showPopUp: false,
              },
              {
                alt: 'Menswear everyday carry',
                image: {
                  src: 'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/nordwood-themes-Nv4QHkTVEaI-unsplash-2.jpg?v=1672787938',
                },
                showPopUp: false,
              },
              {
                alt: 'Man in white t-shirt leaning against wall',
                image: {
                  src: 'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/mad-rabbit-tattoo-X0Ob-bhTdz8-unsplash.jpg?v=1672787932',
                },
                showPopUp: false,
              },
              {
                alt: 'Rack of neutral tone shirts',
                image: {
                  src: 'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/fernando-lavin-fi5YSQfxbVk-unsplash.jpg?v=1672787923',
                },
                showPopUp: false,
              },
            ],
          },

        ],
        defaultValue: [
          {
            header: 'Excepteur sint occaecat cupidatat non proident?',
            body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
            defaultOpen: false,
          },
        ],
        defaultItem: {
          header: 'Excepteur sint occaecat cupidatat non proident?',
          body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          defaultOpen: false,
        },
      },
      {
        label: 'Accordion Settings',
        name: 'accordionSettings',
        component: 'group',
        description: 'Settings for the Accordion Plus',
        fields: [
          {
            label: 'Accordion Width',
            name: 'width',
            component: 'select',
            description: 'Width of the accordion',
            options: [
              { label: 'Full Width', value: 'max-w-none' },
              { label: 'Contained', value: 'max-w-[var(--content-max-lg-width)]' },
              { label: 'Narrow', value: 'max-w-[50rem]' },
            ],
          },
          {
            label: 'Game Day Accordion Header Background Color',
            name: 'headerBgColor',
            component: 'select',
            options: COLORS,
            defaultValue: 'var(--off-white)',
          },
          {
            label: 'Game Day Accordion Header Text Color',
            name: 'headerTextColor',
            component: 'select',
            options: COLORS,
          },
          {
            label: 'Default Open',
            name: 'defaultOpen',
            component: 'toggle',
            description: 'Sets all accordions to be open by default',
            toggleLabels: {
              true: 'On',
              false: 'Off',
            },
          },
          {
            label: 'Items Per Row',
            name: 'itemsPerRow',
            component: 'select',
            description: 'Number of items per row',
            options: [
              { label: '4', value: 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4' },
              { label: '5', value: 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-5' },
              { label: '6', value: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6' },
              { label: '7', value: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-7' },
              { label: '8', value: 'grid-cols-2 sm:grid-cols-4 lg:grid-cols-8' },
            ],
          },
          {
            label: 'Image Size',
            name: 'imageSize',
            component: 'text',
            description: 'Size of image',
          },
          {
            label: 'Image Style',
            name: 'imageStyle',
            component: 'select',
            description: 'Style of image',
            options: [
              { label: 'Default', value: 'default' },
              { label: 'Horizontal', value: 'horizontal' },
            ],
            defaultValue: 'default',
          },
        ],
        defaultValue: {
          width: 'max-w-[50rem]',
          headerBgColor: 'var(--off-white)',
          headerTextColor: 'var(--text)',
          defaultOpen: false,
          itemsPerRow: 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4',
        },
      },
      {
        label: 'Pop Up',
        name: 'popUp',
        description: 'Optional pop up',
        component: 'group',
        fields: [
          {
            label: 'Badge Text',
            name: 'badgeText',
            component: 'text',
            description: 'Text to display on the badge',
          },
          {
            label: 'Pop Up Heading',
            name: 'heading',
            component: 'text',
          },
          {
            label: 'Pop Up Text',
            name: 'text',
            component: 'textarea',
          },
          {
            label: 'HTML',
            name: 'html',
            component: 'html',
          },
          {
            label: 'Typeform id',
            name: 'typeformId',
            component: 'text',
          },
          {
            label: 'Klaviyo Form',
            name: 'klaviyoForm',
            component: 'group',
            fields: [
              {
                label: 'Title',
                name: 'title',
                component: 'text',
                description: 'Heading for the Klaviyo pop up form',
              },
              {
                label: 'Text',
                name: 'text',
                component: 'textarea',
                description: 'Text for the Klaviyo pop up form',
              },
              {
                label: 'Klaviyo List ID',
                name: 'listId',
                component: 'text',
                description: 'Klaviyo list ID for the pop up',
              },
              {
                label: 'Properties',
                name: 'properties',
                component: 'group-list',
                itemProps: {
                  label: '{{item.name}}',
                },
                fields: [
                  {
                    label: 'Property Name',
                    name: 'name',
                    component: 'text',
                    description: 'Name of the property to send to Klaviyo',
                  },
                  {
                    label: 'Pass Link Title',
                    name: 'passLinkTitle',
                    component: 'toggle',
                    description: 'Pass the link title for accordion item as a property value to Klaviyo',
                    toggleLabels: {
                      true: 'On',
                      false: 'Off',
                    },
                  },
                  {
                    label: 'Hide Property',
                    name: 'hide',
                    component: 'toggle',
                    description: 'Hide this property from the pop up form',
                    toggleLabels: {
                      true: 'On',
                      false: 'Off',
                    },
                  }
                ],
              }
            ],
          },
          {
            label: 'Postcript Form',
            name: 'postscriptForm',
            component: 'group',
            fields: [
              {
                label: 'Title',
                name: 'title',
                component: 'text',
                description: 'Heading for the Klaviyo pop up form',
              },
              {
                label: 'Text',
                name: 'text',
                component: 'textarea',
                description: 'Text for the Klaviyo pop up form',
              },
              {
                label: 'Postscript Keyword ID',
                name: 'keywordId',
                component: 'text',
                description: 'Postscript keyword ID for the pop up',
              },
              {
                label: 'Properties',
                name: 'properties',
                component: 'group-list',
                itemProps: {
                  label: '{{item.name}}',
                },
                fields: [
                  {
                    label: 'Property Name',
                    name: 'name',
                    component: 'text',
                    description: 'Name of the property to send to Postscript',
                  },
                  {
                    label: 'Pass Link Title',
                    name: 'passLinkTitle',
                    component: 'toggle',
                    description: 'Pass the link title for accordion item as a property value to Postscript',
                    toggleLabels: {
                      true: 'On',
                      false: 'Off',
                    },
                  },
                  {
                    label: 'Hide Property',
                    name: 'hide',
                    component: 'toggle',
                    description: 'Hide this property from the pop up form',
                    toggleLabels: {
                      true: 'On',
                      false: 'Off',
                    },
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        label: 'Section Settings',
        name: 'section',
        component: 'group',
        description: 'Button style, full width',
        fields: [
          {
            label: 'Hide Section Heading',
            name: 'hideHeading',
            component: 'toggle',
            description: 'Hides the section heading including footer button',
            toggleLabels: {
              true: 'On',
              false: 'Off',
            },
          },
        ],
        defaultValue: {
          hideHeading: false,
        },
      },
    ],
  };
}
